/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Noresultsfound2Inputs */

const en_common_noresultsfound2 = /** @type {(inputs: Common_Noresultsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

/**
* | output |
* | --- |
* | "No results found" |
*
* @param {Common_Noresultsfound2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_noresultsfound2 = /** @type {((inputs?: Common_Noresultsfound2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Noresultsfound2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_noresultsfound2(inputs)
});
export { common_noresultsfound2 as "common_noResultsFound" }